import { render, staticRenderFns } from "./FlaggingView.vue?vue&type=template&id=8c62c54e&scoped=true"
import script from "./FlaggingView.vue?vue&type=script&lang=js"
export * from "./FlaggingView.vue?vue&type=script&lang=js"
import style0 from "./FlaggingView.vue?vue&type=style&index=0&id=8c62c54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c62c54e",
  null
  
)

export default component.exports